import { IconSettingsProvider } from './shared/assets/IconSettingsProvider';
import AppRouter from '@/app/router';
import { SessionProvider } from '@/app/providers/session-provider';
import { TenantProvider } from '@/tenant/tenant-provider';
import { Toaster } from '@/shared/ui/toaster';

export default function App() {
  return (
    <IconSettingsProvider>
      <TenantProvider>
        <SessionProvider>
          <AppRouter />
          <Toaster />
        </SessionProvider>
      </TenantProvider>
    </IconSettingsProvider>
  );
}
